/// <amd-module name="Artifacts/Maven/commands/GetLink" />
import { getLinkCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createGetLinkCommand = getLinkCommandCreator();
